import React, { PureComponent } from 'react'
import styled from 'styled-components'

const DescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: calc(${props => (props.width ? props.width : 33.33)}% - 24px);
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  margin: 12px auto;
  padding: 24px;
  & > p:nth-child(2) {
    font-size: 18px;
    line-height: normal;
    font-weight: 500;
    letter-spacing: normal;
    text-align: left;
    color: #000000;
    padding: 14px 0 10px;
  }
  & > p:nth-child(3) {
    font-size: 15px;
    font-weight: normal;
    line-height: 1.6;
    letter-spacing: normal;
    text-align: left;
    color: #000000;
    padding-bottom: 0px;
    opacity: 0.7;
  }
`

// const Links = styled(Link)`
//   text-decoration: none;
//   color: #4da1ff;
//   display: inline-flex;
//   align-items: center;
// `
// const RightArrow = styled.div`
//   border-right: 2px solid #4da1ff;
//   border-bottom: 2px solid #4da1ff;
//   width: 8px;
//   height: 8px;
//   transform: rotate(-45deg);
// `
export class ProductDescription extends PureComponent {
  render() {
    const { title, description, icon, width } = this.props
    return (
      <DescriptionWrapper width={width}>
        {icon && <img src={require(`../static/${icon}`)} alt="description" />}
        <p>{title}</p>
        <p>{description}</p>
        {/* <Links to="#">
          Learn More <RightArrow />{' '}
        </Links> */}
      </DescriptionWrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ProductDescription.js